import React, { useEffect, useState } from 'react';
import { Info, CheckCircle2, AlertTriangle, Megaphone, X, ExternalLink } from 'lucide-react';
import { fetchMyBanners } from '../services/apiClient';

const STYLES = {
  info: { bg: 'bg-blue-500/15', border: 'border-blue-400/30', text: 'text-blue-100', Icon: Info },
  success: { bg: 'bg-green-500/15', border: 'border-green-400/30', text: 'text-green-100', Icon: CheckCircle2 },
  warning: { bg: 'bg-amber-500/15', border: 'border-amber-400/30', text: 'text-amber-100', Icon: AlertTriangle },
  promo: { bg: 'bg-mentor-accent/15', border: 'border-mentor-accent/40', text: 'text-mentor-text', Icon: Megaphone },
};

const DISMISS_KEY = 'bondmentor.dismissedBanners';

function loadDismissed() {
  try { return JSON.parse(window.localStorage.getItem(DISMISS_KEY) || '[]'); } catch { return []; }
}
function saveDismissed(ids) {
  try { window.localStorage.setItem(DISMISS_KEY, JSON.stringify(ids)); } catch { /* storage unavailable */ }
}

export default function BannerBar() {
  const [banners, setBanners] = useState([]);
  const [dismissed, setDismissed] = useState(loadDismissed);

  useEffect(() => {
    let active = true;
    fetchMyBanners().then((result) => { if (active && result?.ok) setBanners(result.banners || []); });
    return () => { active = false; };
  }, []);

  function dismiss(id) {
    const next = [...new Set([...dismissed, id])];
    setDismissed(next);
    saveDismissed(next);
  }

  const visible = banners.filter((b) => !(b.dismissible && dismissed.includes(b.id)));
  if (visible.length === 0) return null;

  return (
    <div className="space-y-2 mb-4">
      {visible.map((b) => {
        const s = STYLES[b.type] || STYLES.info;
        const Icon = s.Icon;
        return (
          <div key={b.id} className={`flex items-center gap-3 rounded-xl border px-4 py-2.5 ${s.bg} ${s.border} ${s.text}`}>
            <Icon size={17} className="shrink-0" />
            <p className="text-sm flex-1">{b.message}</p>
            {b.ctaLabel && b.ctaUrl && (
              <a href={b.ctaUrl} target="_blank" rel="noreferrer" className="text-sm font-display font-bold inline-flex items-center gap-1 hover:underline underline-offset-2 shrink-0">
                {b.ctaLabel} <ExternalLink size={13} />
              </a>
            )}
            {b.dismissible && (
              <button type="button" onClick={() => dismiss(b.id)} className="shrink-0 rounded-lg p-1 hover:bg-white/10" aria-label="Dismiss"><X size={15} /></button>
            )}
          </div>
        );
      })}
    </div>
  );
}
